import React from 'react';
import { TouchableOpacity } from 'react-native';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import Image from '@src/components/Image';
import { Body2, H2, Subtitle1 } from '@src/components/Typography';
import {
  activeOpacity,
  avatarSize,
  padding,
  windowWidth,
} from '@src/configuration/constants';
import useHandleEntityPress from '@src/hooks/useHandleEntityPress';
import { Notification } from '@src/types';

type Props = {
  item: Notification;
};

type ContainerProps = {
  seen: boolean;
  type: string;
};

const Container = styled.View<ContainerProps>`
  padding: ${padding}px;
  ${({ seen, type }) => {
    if (type === 'BROADCAST') {
      return 'background-color: rgba(38, 186, 172, 0.11)';
    }
    if (!seen) {
      return 'background-color: #F4F4F2';
    }
  }}
`;

const Row = styled.View`
  flex-direction: row;
  align-items: flex-start;
`;

const Content = styled.View`
  flex-direction: column;
  padding-start: ${padding / 2}px;
  padding-end: ${padding / 2}px;
  width: ${windowWidth - avatarSize - padding * 2}px;
`;

const Cover = styled(Image).attrs({
  resizeMode: 'cover',
})`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  width: ${windowWidth - avatarSize - padding * 2}px;
  height: 120px;
`;

const Component: React.FC<Props> = ({ item }) => {
  const handleEntityPress = useHandleEntityPress();
  const { user, content, date, type, seen, cover } = item;
  return (
    <Container type={type} seen={seen}>
      <TouchableOpacity
        activeOpacity={activeOpacity}
        onPress={handleEntityPress(item)}
      >
        <Row>
          <Avatar source={user?.avatar} />
          <Content>
            <Body2>
              {type !== 'BROADCASTُُ' && <H2>{user?.name} </H2>}
              {content}
            </Body2>
            <Subtitle1>{date.fromNow()}</Subtitle1>
            {cover && <Cover source={cover} />}
          </Content>
        </Row>
      </TouchableOpacity>
    </Container>
  );
};

Component.displayName = 'Card';

export default React.memo(Component);
